import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthTokenStorage } from '../auth/auth-token.storage';
import { AuthSessionFacade } from '../auth/auth-session.facade';
import { AppConfigService } from '../config/app-config.service';
import { from, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(AuthTokenStorage);
  const authFacade = inject(AuthSessionFacade);
  const appConfig = inject(AppConfigService);

  // Skip interceptor for OAuth token endpoint requests
  if (req.url === appConfig.oauth.tokenEndpoint) {
    return next(req);
  }

  const accessToken = tokenStorage.getAccessToken();

  if (accessToken && !tokenStorage.isTokenExpired()) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
    });
    return next(authReq);
  }

  // Token is expired but we have a refresh token — try to refresh
  const refreshToken = tokenStorage.getRefreshToken();
  if (refreshToken) {
    return from(authFacade.refreshSession()).pipe(
      switchMap((refreshed) => {
        if (refreshed) {
          const newToken = tokenStorage.getAccessToken();
          const authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${newToken!}`),
          });
          return next(authReq);
        }
        return next(req);
      })
    );
  }

  return next(req);
};
